export default class Nav {
	constructor() {
		this.icon = document.querySelector(".nav__icon");
		// Mobile hamburger icon
		this.icon && this.icon.addEventListener("click", (event) => {
			event.preventDefault();
			document.querySelector(".nav__right").classList.remove("nav__dropdown--open");
			document.querySelector("nav").classList.remove("nav--dark");
			document.querySelector("body").classList.toggle("nav--open");
		});

		// Main menu
		if($(window).width() < 1024){
			this.dropdowns = document.querySelectorAll(".nav__dropdown .nav__link");
			this.dropdowns && this.dropdowns.forEach((dropdown) => {
				dropdown.addEventListener("click", (event) => {
					event.preventDefault();
					document.querySelector("nav").classList.toggle("nav--dark");
					dropdown.parentElement.classList.toggle("nav__dropdown--open");
				});
			});
		} else {
			this.dropdowns = document.querySelectorAll(".nav__dropdown");
			this.dropdowns && this.dropdowns.forEach((dropdown) => {
				dropdown.addEventListener("mouseover", (event) => {
					document.querySelector("nav").classList.add("nav--dark");
				});
				dropdown.addEventListener("mouseout", (event) => {
					document.querySelector("nav").classList.remove("nav--dark");
				});
			});
		}

		// Search toggle
		let searchTrigger = document.querySelector('.nav__search--icon');
		searchTrigger.addEventListener("click", (event) => {
			document.querySelector('.nav__right').classList.toggle("nav__dropdown--open");
			document.querySelector("nav").classList.toggle("nav--dark");
			document.querySelector("body").classList.remove("nav--open");
		});




















		// Site notification banner
		let siteNotification = document.querySelector('.site-notification-banner__close');
		if (siteNotification) {
			siteNotification.addEventListener("click", (event) => {
				siteNotification.parentElement.classList.remove("site-notification-banner--open");
			});
		}

	}
	sticky()
	{

		let navHeight = document.querySelector('.nav__content').offsetHeight;
		let triggerHeight = navHeight;
		let currentScroll = $(window).scrollTop();
		let body = $('body');

		let topMargin = window.innerHeight;

		if (currentScroll > triggerHeight) 
		{
			if (currentScroll <= this.scrollPos && currentScroll >= topMargin) 
			{
				body.addClass("nav--show");
				body.removeClass("nav--hide");
			} else 
			{
				body.removeClass("nav--show");
				body.addClass("nav--hide");
			}
		} else 
		{
			body.removeClass("nav--show");
			body.removeClass("nav--hide");
		}
		
		this.scrollPos = $(window).scrollTop();
	}
}
